var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.model)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"box":"","label":"Роль","items":_vm.roles,"item-text":"name","item-value":"id"},model:{value:(_vm.model.role_id),callback:function ($$v) {_vm.$set(_vm.model, "role_id", $$v)},expression:"model.role_id"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }